import { render, staticRenderFns } from "./ReviewsMessageLogs.vue?vue&type=template&id=4d18fbdc&scoped=true"
import script from "./ReviewsMessageLogs.vue?vue&type=script&lang=js"
export * from "./ReviewsMessageLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18fbdc",
  null
  
)

export default component.exports